import Reveal from "@/components/Reveal";
import { REVIEWS } from "@/data/site";
import { Quote, Star } from "lucide-react";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32 bg-brand-blueDeep relative overflow-hidden">
      <div className="pointer-events-none absolute -bottom-40 -left-24 w-[30rem] h-[30rem] rounded-full bg-brand-green/20 blur-3xl" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green" data-testid="reviews-overline">Reviews</p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tight text-white" data-testid="reviews-heading">
              What Our <span className="font-serif italic font-semibold text-brand-green">Clients Say</span>
            </h2>
          </div>
          <div className="flex items-center gap-3" data-testid="reviews-rating-badge">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-brand-green text-brand-green" />
              ))}
            </div>
            <span className="text-sm font-bold text-white">4.9 / 5 from 200+ B2B clients</span>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="reviews-grid">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.1} className={i % 2 === 1 ? "lg:mt-10" : ""}>
              <figure
                className="flex h-full flex-col rounded-[1.75rem] border border-white/10 bg-white/[0.06] backdrop-blur-md p-8 transition-colors duration-300 hover:bg-white/[0.1]"
                data-testid={`review-card-${r.id}`}
              >
                <Quote size={28} className="text-brand-blue fill-brand-blue/20" />
                <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-200" data-testid={`review-text-${r.id}`}>
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-6 border-t border-white/10 pt-5">
                  <div className="flex gap-0.5 mb-2.5" data-testid={`review-stars-${r.id}`}>
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={13} className="fill-brand-green text-brand-green" />
                    ))}
                  </div>
                  <div className="font-display text-base font-bold text-white" data-testid={`review-name-${r.id}`}>{r.name}</div>
                  <div className="text-xs text-slate-400 mt-0.5" data-testid={`review-role-${r.id}`}>{r.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
